export default __webpack_public_path__ + "static/media/icon-line.bf19624f.svg";